import HeroApiService from '../../services/hero-api.service';

export const useHeroApiService = () => {
  return new HeroApiService();
};
